const e=e=>new Intl.Locale(e);export{e as getLocaleInfo};
